/**
 * funkcja przyjmujaca object literal i zwracajaca wszystkie jego wartosci w zwyklej tablicy
 * bez zachowania kluczy
 *
 * przy podaniu tablicy funkcja zwraca ja bez zmian
 *
 * @param list object literal lub tablica
 * @return {array} object literal
 */

export function toArray(list) {
    if (typeof list === 'undefined') {
        return [];
    }
    if (list.constructor === Array) {
        return list;
    } else if (typeof list === 'object' && list !== null){
        let arr = [];
        for (let prop in list) {
            arr.push(list[prop]);
        }
        return arr;
    }
    return [];
}